import { motion } from "framer-motion";

const FORCE = typeof window !== "undefined" && window.location.search.includes("reveal=1");

export const Reveal = ({ children, className = "", delay = 0, y = 24, as = "div", ...props }) => {
    const MotionTag = motion[as] || motion.div;
    if (FORCE) {
        const Tag = as;
        return <Tag className={className}>{children}</Tag>;
    }
    return (
        <MotionTag
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
            {...props}
        >
            {children}
        </MotionTag>
    );
};

export const Caption = ({ children, className = "" }) => (
    <span className={`font-sans text-xs md:text-sm tracking-[0.28em] uppercase text-sepia ${className}`}>
        {children}
    </span>
);
